import React from 'react'
import {
    CheckCircleFilled,
    CloseCircleFilled,
    ExclamationCircleFilled,
    InfoCircleFilled,
    CloseOutlined
} from '@ant-design/icons'
import classNames from 'classnames'

import styles from './OnboardingNotification.scss'

export type NotificationType = 'success' | 'error' | 'warning' | 'info'

interface OnboardingNotificationProps {
    type: NotificationType
    message: string
    onClose?: () => void
    visible?: boolean
    className?: string
}

const ICONS = {
    success: CheckCircleFilled,
    error: CloseCircleFilled,
    warning: ExclamationCircleFilled,
    info: InfoCircleFilled
}

export const OnboardingNotification: React.FC<OnboardingNotificationProps> = ({
    type,
    message,
    onClose,
    visible = true,
    className
}) => {
    const IconComponent = ICONS[type]

    if (!visible) return null

    return (
        <div
            className={classNames(
                styles.notification,
                {
                    [styles.notificationSuccess]: type === 'success',
                    [styles.notificationError]: type === 'error',
                    [styles.notificationWarning]: type === 'warning',
                    [styles.notificationInfo]: type === 'info'
                },
                className
            )}
        >
            <div className={styles.content}>
                <IconComponent className={styles.icon} />
                <span className={styles.message}>{message}</span>
            </div>
            {onClose && <CloseOutlined className={styles.closeIcon} onClick={onClose} />}
        </div>
    )
}
